<template>
    <div class="container-fluid">
        <b-grid
            caption="Task list"
            :tableOptions="tableOptions"
            :items="queueItems"
            :columns="columns"
            :show-filter="false"
            :show-paging="true"
            @optionChange="getQueueItems">
            <template #beforeFilter>
                <queue-pause-button
                    :show-pause-resume-button="props.showPauseResumeButton"
                    container-class="tasks-pause"></queue-pause-button>
            </template>
            <template v-slot:cell.fileName="{item, column}">
                <span v-html="item.fileName"></span>
            </template>
            <template v-slot:cell.status="{item, column}">
                <span v-html="item.status"></span>
            </template>
        </b-grid>
    </div>
</template>
<script setup lang="ts">
import {computed, ref} from "vue";
import {useQueueStore} from "@/stores/queueStore";
import {BTableColumn, BTableOptions} from "./BTable/BTable.types";
import QueuePauseButton from "./QueuePauseButton.vue";
import {QueueItem} from "@/types";
import {BFilter, BFilterableField} from "./BFilterEditor/BFilterEditor.types";
import BGrid from "./BGrid/BGrid.vue";

const props = defineProps<{
    showPauseResumeButton: boolean;
    noTotal: boolean;
}>();
const queueStore = useQueueStore();

//table settings and column info
var tableOptions = ref({
    totalItemCount: 0,
    itemsPerPage: 25,
    page: 1,
    sortBy: [
        {
            key: "start",
            isDescending: true,
        },
    ],
    pagingMode: props.noTotal ? "noTotal" : "withTotal",
} as BTableOptions);

const columns = computed(() => {
    let data: BTableColumn[] = [];

    data.push(
        {key: "status", text: "Status", sortable: false, value: (item) => item.status},
        {key: "type", text: "Type", sortable: false, value: (item) => item.type},
        {key: "start", text: "Start", sortable: false, value: (item) => item.start},
        {key: "end", text: "End", sortable: false, value: (item) => item.end}
    );

    return data;
});

var queueItems = ref([] as QueueItem[]);
function getQueueItems() {
    queueStore
        .getQueueItems(tableOptions.value, [] as BFilter[], [] as BFilterableField[], tableOptions.value.sortBy)
        .then((response) => {
            if (!props.noTotal) {
                tableOptions.value.totalItemCount = response.data?.total ?? 0;
            }
            if (Array.isArray(response.data.data)) {
                queueItems.value = response.data.data;
            }
        });
}

getQueueItems();
</script>
<style lang="scss">
.tasks-pause {    
  margin-bottom: .5rem !important;
  align-items: flex-end !important;
  display: flex !important;

  >button {
    padding-bottom: 0;
    position: relative;
    top:5px;
  }
}
</style>
